export default __webpack_public_path__ + "static/media/Meeting_placeholder.ef46766d.jpg";